import { getSessionInfo } from './session-store';
export var SESSION_USER_PREFERENCES;
(function (SESSION_USER_PREFERENCES) {
    SESSION_USER_PREFERENCES["NOTIFY_ON_SHARE"] = "notifyOnShare";
    SESSION_USER_PREFERENCES["PREFERRED_LOCALE"] = "preferredLocale";
    SESSION_USER_PREFERENCES["LAST_SEEN_LOCALE"] = "lastSeenLocale";
    SESSION_USER_PREFERENCES["SAVED_AUTHOR_FILTER"] = "savedAuthorFilter";
    SESSION_USER_PREFERENCES["ANALYST_ONBOARDING_COMPLETE"] = "analystOnboardingComplete";
    SESSION_USER_PREFERENCES["NUM_TIMES_DISPLAY_NAME_DIALOG_SHOWN"] = "numTimesDisplayNameDialogShown";
    SESSION_USER_PREFERENCES["MONITOR_RULE_AUTO_CREATE"] = "monitorRuleAutoCreate";
    SESSION_USER_PREFERENCES["SCHEDULE_JOB_AUTO_CREATE"] = "scheduleJobAutoCreate";
    SESSION_USER_PREFERENCES["SPOTTER_FULL_EXPERIENCE"] = "spotterFullExperienceEnabled";
    SESSION_USER_PREFERENCES["CHART_CONTEXT_MENU_EXPERIENCE"] = "chartContextMenuExperience";
    SESSION_USER_PREFERENCES["USER_SCOPED_PREFERENCES_MEMORY"] = "userPersonalMemoryDisabled";
})(SESSION_USER_PREFERENCES || (SESSION_USER_PREFERENCES = {}));
export const getExposedUserPreferences = () => {
    const sessionInfo = getSessionInfo();
    if (!sessionInfo || !sessionInfo.userPreferences) {
        return {};
    }
    return sessionInfo.userPreferences;
};
export const getExposedUserPreference = (key) => {
    const sessionInfo = getSessionInfo();
    if (!sessionInfo || !sessionInfo.userPreferences) {
        return null;
    }
    return sessionInfo.userPreferences[key];
};
export const setExposedUserPreference = (key, value) => {
    const sessionInfo = getSessionInfo();
    if (!sessionInfo || !sessionInfo.userPreferences) {
        return;
    }
    sessionInfo.userPreferences[key] = value;
    if (key === SESSION_USER_PREFERENCES.SAVED_AUTHOR_FILTER) {
    }
};
//# sourceMappingURL=user-preferences.js.map